import { Typography } from "@mui/material";
import { EuropaveiIcon } from "./ManeuverLabelIcons/EuropaveiIcon";
import { FylkesveiIcon } from "./ManeuverLabelIcons/FylkesveiIcon";

export interface IManeuverLabelProps {
    maneuverText: string;
}

export default function ManeuverLabel(props: IManeuverLabelProps) {
    const {maneuverText} = props;

    //Text is split into an array. The first element is the road identifier, the second is the maneuver text.
    const maneuverTextArray = maneuverText.split("} ");

    function createElementForRoadIdentifier() {
        maneuverTextArray[0] = maneuverTextArray[0].replace("{", "");
        maneuverTextArray[0] = maneuverTextArray[0].replace("}", "");

        if (maneuverTextArray[0].includes("E")) {
            return <EuropaveiIcon roadIdentifier={maneuverTextArray[0]} />
        }

        if (maneuverTextArray[0].includes("F")) {
            return <FylkesveiIcon roadIdentifier={maneuverTextArray[0]} />
        }

        return (
            // <Typography>{maneuverTextArray[0]}</Typography>
            <></>
        );
    }

    return (
        <div style={{display:"flex", alignItems:"top"}}>
            {createElementForRoadIdentifier()}<Typography>{maneuverTextArray[1]}</Typography>
        </div>
    );
}

export interface IRoadIdentifierIconProps {
    roadIdentifier: string;
}